import React from "react";

export const AuthEnabledContext = React.createContext(false)
